import { baseRouteMaker, routes } from "../../../constants/routeConsts";
import { t } from "i18next";

export const useHelpAndSupportMenuUtils = () => {
  const tempMenuGroup = [];

  /* menuItemHelpAndSupport */
  const menuItemHelpAndSupport = {
    id: "help-and-support",
    title: t("AppModuleNames.SuperAdmin.HelpAndSupport"),
    url: baseRouteMaker(routes.HELP_AND_SUPPORT_LIST),
  };
  tempMenuGroup.push(menuItemHelpAndSupport);
  /* menuItemHelpAndSupport */

  return tempMenuGroup;
};
